import { Reveal } from "../components/Reveal";
import { useLang } from "../lib/i18n";

export const NoResult = () => {
  const { t } = useLang();
  return (
    <section data-testid="no-result-banner" className="relative overflow-hidden border-y border-edge/40 bg-white py-20 shadow-[0_1px_30px_rgba(24,21,16,0.07)] md:py-24">
      <div className="pointer-events-none absolute left-1/2 top-1/2 h-[300px] w-[700px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#f7f1dd] blur-[120px]" />
      <Reveal className="relative mx-auto max-w-5xl px-6 text-center">
        <p className="font-archivo text-4xl font-black leading-tight tracking-tight md:text-6xl" data-testid="no-result-text">
          <span className="text-cream">{t.noResult} </span>
          <span className="amber-text-gradient">{t.noInvoice}</span>
        </p>
      </Reveal>
    </section>
  );
};
